
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/paragraph-writer",
      function () {
        return require("private-next-pages/app/tools/paragraph-writer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/paragraph-writer"])
      });
    }
  